// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/images/baloa-background-login.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signup-claim-account__container {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: auto;
    gap: var( --grid-gap );
    grid-template-areas: "left left left left right right right right right right right right";
    background-color: var( --white-color );
    height: 150vh;
}

.signup-claim-account__container__left-col {
    grid-area: left;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 150vh;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}

.signup-claim-account__container__left-col img {
    width: 180px;
    margin-top: 68px;
    margin-left: 48px;
}

.signup-claim-account__container__right-col {
    grid-column: 7 / 11;
    margin-top: 175px;
}

.signup-claim-account__text.baloa-normal {
    color: var(--primary-dark-color);
    margin: 38px 0 48px 0px;
}

.signup-claim-account__buttons {
    display: flex;
    justify-content: flex-end;
    margin: calc( var( --space-x2 ) + var( --space-quarter ) ) 0 calc( var( --space-x3 ) + var( --space-x2 ) ) 0;
}

.signup-claim-account__buttons__back.secondary-button{
    font-size: calc(var(--space) + var(--space-eighth) + 1px);
    font-weight: var(--font-medium);
    line-height: calc(var(--space) + var(--space-quarter) + var(--space-eighth));
    margin-right: 20px;
}

.signup-claim-account__container__right-col__title {
    display: flex;
    align-items: center;
}

.signup-claim-account__container__right-col__title .icon-arrow-left {
    margin-right: var(--space-x2);
    cursor: pointer;
}

.signup-claim-account__container__right-col .league-search-member-team-form__box .input-search__input {
    border-radius: 4px;
    border: 1px solid var( --new-gray-background-color );
    background: var( --new-background-color );
}

.signup-claim-account__historic-columns{
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 16px;
}

.signup-claim-account__historic-columns__column {
    width: 50%;
    max-height: 330px;
}

.signup-claim-account__user-data__date {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
    margin-top: 16px;
}

.signup-claim-account__user-data .baloa-names{
    color: var(--primary-very-dark-color);
}

.signup-claim-account__user-data .baloa-names.subtitle{
    font-weight: var(--font-regular);
}

.signup-claim-account__player-info {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    border-radius: 8px;
    border: 1px solid var(--new-gray-background-color);
    padding: 10px 12px;
    margin-top: 16px;
    gap: 8px;
}

.signup-claim-account__player-info__photo img{
    width: 44px;
    height: 44px;
    border-radius: 50%;
}

.signup-claim-account__player-info__photo .icon-ball{
    color: var( --white-color );
    font-size: 36px;
    border-radius: 50%;
    padding: 4px; 
}


.signup-claim-account__player-info .baloa-hyperlink {
    color: var(--primary-dark-color);
}

.signup-claim-account__player-info .baloa-table {
    color: var(--primary-very-dark-color);
}

.signup-claim-account__historic-columns__teams__photo img,
.signup-claim-account__historic-columns__tournaments__photo img{
    width: 40px;
    height: 40px;
    border-radius: 50%;
}

.signup-claim-account__historic-columns__teams__photo,
.signup-claim-account__historic-columns__tournaments__photo {
    width: 40px;
    height: 40px;
}

.signup-claim-account__historic-columns__teams__photo .icon-ball,
.signup-claim-account__historic-columns__tournaments__photo .icon-ball {
    color: var( --white-color );
    font-size: 32px;
    border-radius: 50%;
    padding: 4px;
    display: flex;
    align-items: center;  
}

.signup-claim-account__historic-columns__teams,
.signup-claim-account__historic-columns__tournaments {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: 12px;
}

.signup-claim-account__historic-columns__teams .baloa-table,
.signup-claim-account__historic-columns__tournaments .baloa-table {
    font-weight: var(--font-medium);
    color: var(--primary-very-dark-color);
}

.signup-claim-account__historic-columns__teams__tags,
.signup-claim-account__historic-columns__tournaments__tags {
    display: flex;
    align-items: center;
    margin-top: 4px;
}

.signup-claim-account__historic-columns__tournaments__tag,
.signup-claim-account__historic-columns__team__tag {
    background: var(--new-grey-light-background-color);
    border-radius: 23px;
    padding: 2px 4px;
    margin-right: 4px;
    border: 1px solid var(--new-grey-border-color);
    color: var(--primary-dark-color);
}

.signup-claim-account__info-msg {
    display: flex;
    align-items: center;
    padding: 10px;
    border-radius: 4px;
    background: var( --new-informative-banner-bg-color);
}

.signup-claim-account__info-msg .hubicon-info {
    font-size: 22px;
    margin-right: 8px;
    color:  var( --new-informative-banner-bg-color);
}

.signup-claim-account__info-msg .hubicon-info::before {
    color:  var( --new-informative-banner-color);
}

.signup-claim-account__info-msg  .baloa-names {
    color: var(--primary-very-dark-color);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .signup-claim-account__container {
        display: block;
        height: 100vh;
    } 
    .signup-claim-account__container__left-col {
        height: 0;
        background-image: none;
    }
    .signup-claim-account__container__left-col a {
        display: flex;
        justify-content: center;
    }
    .signup-claim-account__container__left-col img {
        width: 100px;
        margin-top: calc( var(--space-x3) + var(--space-quarter) + var(--space-eighth) );
        margin-left: 0;
    }
    .signup-claim-account__container__right-col {
        margin-top: 112px;
        height: calc(100% - 214px);
    }
    .signup-claim-account__container__right-col__title {
        margin-left: var(--space);
    }
    .signup-claim-account__container__right-col .league-search-member-team-container{
        margin: 0 12px;
        width: -webkit-fill-available;
    }

    .signup-claim-account__container__right-col .league-search-member-team-form__box{
        padding-right: 0;
    }

    .signup-claim-account__text.baloa-normal {
        margin: var(--space-and-half) var(--space);
    }

    .signup-claim-account__buttons {
       padding: 0 12px;
       bottom: var(--space);
       position: absolute;
       width: -webkit-fill-available;
       display: block;
       border-top: 1px solid var(--new-gray-background-color);
       margin: unset;
    }

    .signup-claim-account__info-msg {
        margin: 0 12px;
    }

    .signup-claim-account__player-info {
        margin: 16px 12px 0 12px;
    }

    .signup-claim-account__user-data__date {
        margin: 24px 12px 0 12px;
    }

    .signup-claim-account__historic-columns {
        margin-top: 0;
        display: block;
    }

    .signup-claim-account__historic-columns__column {
        margin: 24px 12px 0 12px;
        width: auto;
        max-height: unset;
    }

    .signup-claim-account__buttons__back{
        width: 100%;
        margin-top: 12px;
    }
    .signup-claim-account__buttons__forward{
        width: 100%;
        margin-top: 6px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/authentication/components/signup-claim-account/SignUpClaimAccountComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sCAAsC;IACtC,wBAAwB;IACxB,sBAAsB;IACtB,0FAA0F;IAC1F,sCAAsC;IACtC,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,yDAA6E;IAC7E,aAAa;IACb,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,4GAA4G;AAChH;;AAEA;IACI,yDAAyD;IACzD,+BAA+B;IAC/B,4EAA4E;IAC5E,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,oDAAoD;IACpD,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,2BAA2B;IAC3B,kBAAkB;IAClB,kDAAkD;IAClD,kBAAkB;IAClB,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;;AAGA;IACI,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;;IAEI,+BAA+B;IAC/B,qCAAqC;AACzC;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;IAEI,kDAAkD;IAClD,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,8CAA8C;IAC9C,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,mDAAmD;AACvD;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,+CAA+C;AACnD;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,qCAAqC;AACzC;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,cAAc;QACd,aAAa;IACjB;IACA;QACI,SAAS;QACT,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,uBAAuB;IAC3B;IACA;QACI,YAAY;QACZ,gFAAgF;QAChF,cAAc;IAClB;IACA;QACI,iBAAiB;QACjB,0BAA0B;IAC9B;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,cAAc;QACd,6BAA6B;IACjC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,0CAA0C;IAC9C;;IAEA;OACG,eAAe;OACf,oBAAoB;OACpB,kBAAkB;OAClB,6BAA6B;OAC7B,cAAc;OACd,sDAAsD;OACtD,aAAa;IAChB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,wBAAwB;QACxB,WAAW;QACX,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,eAAe;IACnB;AACJ","sourcesContent":[".signup-claim-account__container {\n    display: grid;\n    grid-template-columns: repeat(12, 1fr);\n    grid-template-rows: auto;\n    gap: var( --grid-gap );\n    grid-template-areas: \"left left left left right right right right right right right right\";\n    background-color: var( --white-color );\n    height: 150vh;\n}\n\n.signup-claim-account__container__left-col {\n    grid-area: left;\n    background-image: url(\"../../../../assets/images/baloa-background-login.png\");\n    height: 150vh;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.signup-claim-account__container__left-col img {\n    width: 180px;\n    margin-top: 68px;\n    margin-left: 48px;\n}\n\n.signup-claim-account__container__right-col {\n    grid-column: 7 / 11;\n    margin-top: 175px;\n}\n\n.signup-claim-account__text.baloa-normal {\n    color: var(--primary-dark-color);\n    margin: 38px 0 48px 0px;\n}\n\n.signup-claim-account__buttons {\n    display: flex;\n    justify-content: flex-end;\n    margin: calc( var( --space-x2 ) + var( --space-quarter ) ) 0 calc( var( --space-x3 ) + var( --space-x2 ) ) 0;\n}\n\n.signup-claim-account__buttons__back.secondary-button{\n    font-size: calc(var(--space) + var(--space-eighth) + 1px);\n    font-weight: var(--font-medium);\n    line-height: calc(var(--space) + var(--space-quarter) + var(--space-eighth));\n    margin-right: 20px;\n}\n\n.signup-claim-account__container__right-col__title {\n    display: flex;\n    align-items: center;\n}\n\n.signup-claim-account__container__right-col__title .icon-arrow-left {\n    margin-right: var(--space-x2);\n    cursor: pointer;\n}\n\n.signup-claim-account__container__right-col .league-search-member-team-form__box .input-search__input {\n    border-radius: 4px;\n    border: 1px solid var( --new-gray-background-color );\n    background: var( --new-background-color );\n}\n\n.signup-claim-account__historic-columns{\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    margin-top: 16px;\n}\n\n.signup-claim-account__historic-columns__column {\n    width: 50%;\n    max-height: 330px;\n}\n\n.signup-claim-account__user-data__date {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 4px;\n    margin-top: 16px;\n}\n\n.signup-claim-account__user-data .baloa-names{\n    color: var(--primary-very-dark-color);\n}\n\n.signup-claim-account__user-data .baloa-names.subtitle{\n    font-weight: var(--font-regular);\n}\n\n.signup-claim-account__player-info {\n    display: flex;\n    align-items: flex-start;\n    justify-content: flex-start;\n    border-radius: 8px;\n    border: 1px solid var(--new-gray-background-color);\n    padding: 10px 12px;\n    margin-top: 16px;\n    gap: 8px;\n}\n\n.signup-claim-account__player-info__photo img{\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;\n}\n\n.signup-claim-account__player-info__photo .icon-ball{\n    color: var( --white-color );\n    font-size: 36px;\n    border-radius: 50%;\n    padding: 4px; \n}\n\n\n.signup-claim-account__player-info .baloa-hyperlink {\n    color: var(--primary-dark-color);\n}\n\n.signup-claim-account__player-info .baloa-table {\n    color: var(--primary-very-dark-color);\n}\n\n.signup-claim-account__historic-columns__teams__photo img,\n.signup-claim-account__historic-columns__tournaments__photo img{\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n}\n\n.signup-claim-account__historic-columns__teams__photo,\n.signup-claim-account__historic-columns__tournaments__photo {\n    width: 40px;\n    height: 40px;\n}\n\n.signup-claim-account__historic-columns__teams__photo .icon-ball,\n.signup-claim-account__historic-columns__tournaments__photo .icon-ball {\n    color: var( --white-color );\n    font-size: 32px;\n    border-radius: 50%;\n    padding: 4px;\n    display: flex;\n    align-items: center;  \n}\n\n.signup-claim-account__historic-columns__teams,\n.signup-claim-account__historic-columns__tournaments {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    margin-top: 12px;\n}\n\n.signup-claim-account__historic-columns__teams .baloa-table,\n.signup-claim-account__historic-columns__tournaments .baloa-table {\n    font-weight: var(--font-medium);\n    color: var(--primary-very-dark-color);\n}\n\n.signup-claim-account__historic-columns__teams__tags,\n.signup-claim-account__historic-columns__tournaments__tags {\n    display: flex;\n    align-items: center;\n    margin-top: 4px;\n}\n\n.signup-claim-account__historic-columns__tournaments__tag,\n.signup-claim-account__historic-columns__team__tag {\n    background: var(--new-grey-light-background-color);\n    border-radius: 23px;\n    padding: 2px 4px;\n    margin-right: 4px;\n    border: 1px solid var(--new-grey-border-color);\n    color: var(--primary-dark-color);\n}\n\n.signup-claim-account__info-msg {\n    display: flex;\n    align-items: center;\n    padding: 10px;\n    border-radius: 4px;\n    background: var( --new-informative-banner-bg-color);\n}\n\n.signup-claim-account__info-msg .hubicon-info {\n    font-size: 22px;\n    margin-right: 8px;\n    color:  var( --new-informative-banner-bg-color);\n}\n\n.signup-claim-account__info-msg .hubicon-info::before {\n    color:  var( --new-informative-banner-color);\n}\n\n.signup-claim-account__info-msg  .baloa-names {\n    color: var(--primary-very-dark-color);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .signup-claim-account__container {\n        display: block;\n        height: 100vh;\n    } \n    .signup-claim-account__container__left-col {\n        height: 0;\n        background-image: none;\n    }\n    .signup-claim-account__container__left-col a {\n        display: flex;\n        justify-content: center;\n    }\n    .signup-claim-account__container__left-col img {\n        width: 100px;\n        margin-top: calc( var(--space-x3) + var(--space-quarter) + var(--space-eighth) );\n        margin-left: 0;\n    }\n    .signup-claim-account__container__right-col {\n        margin-top: 112px;\n        height: calc(100% - 214px);\n    }\n    .signup-claim-account__container__right-col__title {\n        margin-left: var(--space);\n    }\n    .signup-claim-account__container__right-col .league-search-member-team-container{\n        margin: 0 12px;\n        width: -webkit-fill-available;\n    }\n\n    .signup-claim-account__container__right-col .league-search-member-team-form__box{\n        padding-right: 0;\n    }\n\n    .signup-claim-account__text.baloa-normal {\n        margin: var(--space-and-half) var(--space);\n    }\n\n    .signup-claim-account__buttons {\n       padding: 0 12px;\n       bottom: var(--space);\n       position: absolute;\n       width: -webkit-fill-available;\n       display: block;\n       border-top: 1px solid var(--new-gray-background-color);\n       margin: unset;\n    }\n\n    .signup-claim-account__info-msg {\n        margin: 0 12px;\n    }\n\n    .signup-claim-account__player-info {\n        margin: 16px 12px 0 12px;\n    }\n\n    .signup-claim-account__user-data__date {\n        margin: 24px 12px 0 12px;\n    }\n\n    .signup-claim-account__historic-columns {\n        margin-top: 0;\n        display: block;\n    }\n\n    .signup-claim-account__historic-columns__column {\n        margin: 24px 12px 0 12px;\n        width: auto;\n        max-height: unset;\n    }\n\n    .signup-claim-account__buttons__back{\n        width: 100%;\n        margin-top: 12px;\n    }\n    .signup-claim-account__buttons__forward{\n        width: 100%;\n        margin-top: 6px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
